import { useState, useEffect } from "react";
import "./CardCarousel.css";
import CarouselArrow from "./CarouselArrow";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
}

export default function CardCarousel({ items, itemsPerSlide = 3, renderItem }) {
  const [current, setCurrent] = useState(0);
  const isMobile = useIsMobile();
  const effectiveItemsPerSlide = isMobile ? 1 : itemsPerSlide;

  const slides = [];
  for (let i = 0; i < items.length; i += effectiveItemsPerSlide) {
    slides.push(items.slice(i, i + effectiveItemsPerSlide));
  }

  useEffect(() => {
    setCurrent(0);
  }, [effectiveItemsPerSlide, items.length]);

  if (slides.length === 0) return null;

  const safeCurrent = Math.min(current, slides.length - 1);
  const prev = () => setCurrent((c) => (c - 1 + slides.length) % slides.length);
  const next = () => setCurrent((c) => (c + 1) % slides.length);

  return (
    <div className="card-carousel">
      {slides.length > 1 && (
        <CarouselArrow direction="left" onClick={prev} />
      )}

      <div className="card-carousel-overflow">
        <div
          className="card-carousel-track"
          style={{ transform: `translateX(-${safeCurrent * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <div key={i} className="card-carousel-slide">
              {slide.map((item, j) => renderItem(item, j))}
            </div>
          ))}
        </div>
      </div>

      {slides.length > 1 && (
        <CarouselArrow direction="right" onClick={next} />
      )}

      {slides.length > 1 && (
        <div className="card-carousel-dots">
          {slides.map((_, i) => (
            <span
              key={i}
              className={`cdot ${i === safeCurrent ? "active" : ""}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
